import { useRef, useState } from "react";
// material
// import { alpha } from "@material-ui/core/styles";
// import {
//   Box,
//   Avatar,
//   Button,
//   Divider,
//   Typography,
//   Chip,
//   Alert,
// } from "@material-ui/core";

import { alpha } from '@mui/material/styles';

import {
  Box,
  Avatar,
  Button,
  Divider,
  Typography,
  Chip,
  Alert,
} from '@mui/material';
// components


// components
import MenuPopover from "./MenuPopover";
import { MIconButton } from "./@material-extend";
import { useAuth } from '../authProvider/hook/useAuth';

const base_btn_component = 'btn_account_switcher'
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSignout = () => {
    window['jnzauth'].signOut()
  };

  const handleManageProfile = () => {
    window['jnzauth'].manangeProfile()
  };

  return (
    <>
      <MIconButton
        rel='gtmbtn'
        id={`${base_btn_component}_open`}
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: {
            xs: 25,
            sm: 48
          },
          height: {
            xs: 25,
            sm: 48
          },
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar
          alt="My Avatar"
          src={user?.image_url}
          sx={{
            width: {
              xs: 25,
              sm: 40
            },
            height: {
              xs: 25,
              sm: 40
            }
          }}
        />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{
          maxWidth: 439,
          width: 'calc(100% - 32px)',
        }}
      >

        <Box sx={{ mx: 1, mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Alert icon={false} color="info" sx={{ mb: 3, width: '100%' }}> {'this account is managed by big.co.th'}  </Alert>
          <Avatar
            alt="My Avatar"
            src={user?.image_url}
            sx={{ width: 100, height: 100, mb: 2 }}
          />
          <Typography variant="h6" sx={{ mb: 0.5 }}> {user?.firstname} {user?.lastname} </Typography>
          <Typography sx={{ mb: 2 }} variant="body1" color="text.secondary" > {user?.primary_email} </Typography>

          <Box sx={{ mb: 3 }}>
            <Chip rel='gtmbtn' id={`${base_btn_component}_profile`}
              label="Manage you Jenosize Account" variant="outlined" onClick={handleManageProfile} />
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: 'flex', alignItems: "center", justifyContent: 'center', my: 3 }}>
          <Button rel='gtmbtn' id={`${base_btn_component}_signout`}
            variant="outlined" color="inherit" size="large" onClick={handleSignout}> {'Sign out of all accounts'} </Button>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: 'flex', alignItems: "center", justifyContent: 'center', my: 3 }}>
          <Typography variant="body1" color="text.secondary"> {'Privacy Policy'}</Typography>
          <Box
            component="span"
            sx={{ width: 4, height: 4, borderRadius: "50%", bgcolor: "text.secondary", mx: 2 }}
          />
          <Typography variant="body1" color="text.secondary"> {'Terms of Service'}</Typography>
        </Box>

      </MenuPopover>
    </>
  );
}

